module.exports = __webpack_public_path__ + "assets/2ac3c499799a19e6897316124ab50cce.mp3";